<template>
  <div>
    <!-- Delete old Notice modal once all ordering flows are complete (p@t, o@t, orderAhead@t etc..) -->
    <modal
      v-slot="{ data }"
      name="notice"
      modal-style="compact"
    >
      <div class="section center">
        <h2
          v-if="data.title"
          :class="['title title--2', !data.useSecondaryStyle && 'primary' ]"
        >
          {{ data.title }}
        </h2>

        <p
          :class="['dark bigger', data.useSecondaryStyle && 'dark-gray']"
          v-html="data.description"
        />

        <button
          v-if="!data.excludeButton"
          type="button"
          class="button button--primary button--large button--auto-width spacing-top"
          @click="$closeModal('notice')"
        >
          Okay
        </button>
      </div>
    </modal>

    <modal
      v-slot="{ data }"
      name="error"
      modal-style="compact"
      :is-required="true"
    >
      <div class="section center">
        <span class="icon icon--block icon--medium far fa-exclamation-circle danger" />

        <p
          v-for="message in data.messages"
          :key="message"
        >
          {{ message }}
        </p>

        <button
          type="button"
          class="button button--primary button--large button--auto-width"
          @click="$closeModal('error')"
        >
          Okay
        </button>
      </div>
    </modal>

    <sign-up-modal />

    <sign-in-modal />

    <single-sign-on-modal />

    <reset-password-modal />

    <two-factor-auth-modal />

    <!-- Not to be confused with <two-factor-auth-modal /> -->
    <sign-in-with-passcode-modal />

    <request-two-factor-auth-passcode-modal />

    <menu-item-modal />

    <read-only-menu-item-modal />

    <menu-filter-modal />

    <claim-gifted-points-modal />

    <notice-modal />

    <confirmation-modal />

    <edit-group-order-modal />

    <delivery-not-available-modal />

    <location-details-modal />

    <ordering-error-modal />

    <edit-order-address-details-modal />

    <age-verification-modal />

    <empty-cart-modal />

    <menu-unavailable-modal />

    <no-selected-location-modal />

    <delete-account-modal />

    <terms-and-conditions-modal />

    <order-history-receipt-modal />

    <gift-card-receipt-modal />

    <!-- Gift Card Add, View, Purchase, Merge and Reload Modals -->
    <gift-card-management-modals />

    <edit-favorite-order-modal />

    <upsell-modal />

    <upsell-item-details-modal />

    <!-- Refer friend, scan to earn, scan to learn more, manual barcode entry and scan to check in modals -->
    <loyalty-scanning-modals />

    <offer-details-modal />

    <challenge-details-modal />

    <gift-loyalty-points-modal />

    <select-favorite-store-modal />

    <in-app-message-modal />

    <inbox-message-modal />

    <add-gift-card-at-checkout-modal />

    <unavailable-items-modal />

    <card-scanning-management-modal />

    <offer-in-store-redemption-modal />

    <items-exceeding-inventory-modal />

    <reorder-items-modal />

    <loyalty-program-details-modal />

    <loyalty-terms-and-conditions-modal />

    <enroll-in-loyalty-modal />

    <collect-account-info-modal />

    <enter-table-number-modal />

    <privacy-policy-modal />

    <scan-to-pay-receipt-modal />

    <open-tab-finish-ordering-modal />

    <open-tab-onboarding-modal />

    <check-gift-card-balance-modal />

    <confirm-fulfillment-time-modal />

    <select-table-top-device-order-modal />

    <order-item-rating-modal />

    <unavailable-favorite-item-modal />
  </div>
</template>


<script>
  import OfferInStoreRedemptionModal from './offer-in-store-redemption-modal/index.vue';

  import SignUpModal from './sign-up-modal/index.vue';
  import SignInModal from './sign-in-modal/index.vue';
  import SingleSignOnModal from './single-sign-on-modal/index.vue';
  import ResetPasswordModal from './reset-password-modal/index.vue';
  import TwoFactorAuthModal from './two-factor-auth-modal/index.vue';
  import SignInWithPasscodeModal from './sign-in-with-passcode-modal/index.vue';
  import RequestTwoFactorAuthPasscodeModal from './request-two-factor-auth-passcode-modal/index.vue';
  import ClaimGiftedPointsModal from './claim-gifted-points-modal/index.vue';
  import EditOrderAddressDetailsModal from './cf-edit-order-address-details-modal/index.vue';
  import EditGroupOrderModal from './edit-group-order-modal/index.vue';
  import DeliveryNotAvailableModal from './delivery-not-available-modal/index.vue';
  import LocationDetailsModal from './location-details-modal/index.vue';
  import AgeVerificationModal from './age-verification-modal/index.vue';
  import MenuItemModal from './menu-item-modal/index.vue';
  import MenuFilterModal from './menu-filter-modal/index.vue';
  import OrderingErrorModal from './ordering-error-modal/index.vue';
  import EmptyCartModal from './empty-cart-modal/index.vue';
  import MenuUnavailableModal from './menu-unavailable-modal/index.vue';
  import NoSelectedLocationModal from './no-selected-location-modal/index.vue';
  import NoticeModal from './notice-modal/index.vue';
  import ConfirmationModal from './confirmation-modal/index.vue';
  import UpsellModal from './upsell-modal/index.vue';
  import UpsellItemDetailsModal from './upsell-item-details-modal/index.vue';
  import DeleteAccountModal from './delete-account-modal/index.vue';
  import TermsAndConditionsModal from './terms-and-conditions-modal/index.vue';
  import OrderHistoryReceiptModal from './order-history-receipt-modal/index.vue';
  import GiftCardReceiptModal from './gift-card-receipt-modal/index.vue';
  import GiftCardManagementModals from './gift-card-management-modals/index.vue';
  import EditFavoriteOrderModal from './edit-favorite-order-modal/index.vue';
  import LoyaltyScanningModals from './loyalty-scanning-modals/index.vue';
  import GiftLoyaltyPointsModal from './gift-loyalty-points-modal/index.vue';
  import SelectFavoriteStoreModal from './select-favorite-store-modal/index.vue';
  import InAppMessageModal from './in-app-message-modal/index.vue';
  import InboxMessageModal from './inbox-message-modal/index.vue';
  import OfferDetailsModal from './offer-details-modal/index.vue';
  import ChallengeDetailsModal from './challenge-details-modal/index.vue';
  import AddGiftCardAtCheckoutModal from './add-gift-card-at-checkout-modal/index.vue';
  import UnavailableItemsModal from './unavailable-items-modal/index.vue';
  import CardScanningManagementModal from './card-scanning-management-modal/index.vue';
  import ItemsExceedingInventoryModal from './items-exceeding-inventory-modal/index.vue';
  import ReorderItemsModal from './reorder-items-modal/index.vue';
  import LoyaltyProgramDetailsModal from './loyalty-program-details-modal/index.vue';
  import LoyaltyTermsAndConditionsModal from './loyalty-terms-and-conditions-modal/index.vue';
  import EnrollInLoyaltyModal from './enroll-in-loyalty-modal/index.vue';
  import CollectAccountInfoModal from './collect-account-info-modal/index.vue';
  import EnterTableNumberModal from './enter-table-number-modal/index.vue';
  import PrivacyPolicyModal from './privacy-policy-modal/index.vue';
  import ScanToPayReceiptModal from './scan-to-pay-receipt-modal/index.vue';
  import OpenTabFinishOrderingModal from './open-tab-finish-ordering-modal/index.vue';
  import OpenTabOnboardingModal from './open-tab-onboarding-modal/index.vue';
  import CheckGiftCardBalanceModal from './check-gift-card-balance-modal/index.vue';
  import ConfirmFulfillmentTimeModal from './confirm-fulfillment-time-modal/index.vue';
  import SelectTableTopDeviceOrderModal from './select-table-top-device-order-modal/index.vue';
  import OrderItemRatingModal from './order-item-rating-modal/index.vue';
  import UnavailableFavoriteItemModal from './unavailable-favorite-item-modal/index.vue';

  import ReadOnlyMenuItemModal from '@/components/globals/read-only-menu-item-modal.vue';

  export default {
    name: 'AppModals',

    components: {
      SignUpModal,
      SignInModal,
      SingleSignOnModal,
      ResetPasswordModal,
      TwoFactorAuthModal,
      SignInWithPasscodeModal,
      RequestTwoFactorAuthPasscodeModal,
      DeliveryNotAvailableModal,
      OfferDetailsModal,
      ChallengeDetailsModal,
      OfferInStoreRedemptionModal,
      MenuItemModal,
      EditOrderAddressDetailsModal,
      ClaimGiftedPointsModal,
      EditGroupOrderModal,
      LocationDetailsModal,
      AgeVerificationModal,
      NoticeModal,
      ConfirmationModal,
      OrderingErrorModal,
      EmptyCartModal,
      MenuFilterModal,
      MenuUnavailableModal,
      NoSelectedLocationModal,
      UpsellModal,
      UpsellItemDetailsModal,
      DeleteAccountModal,
      TermsAndConditionsModal,
      OrderHistoryReceiptModal,
      GiftCardReceiptModal,
      GiftCardManagementModals,
      EditFavoriteOrderModal,
      LoyaltyScanningModals,
      GiftLoyaltyPointsModal,
      SelectFavoriteStoreModal,
      InAppMessageModal,
      InboxMessageModal,
      AddGiftCardAtCheckoutModal,
      UnavailableItemsModal,
      CardScanningManagementModal,
      ItemsExceedingInventoryModal,
      ReorderItemsModal,
      LoyaltyProgramDetailsModal,
      LoyaltyTermsAndConditionsModal,
      EnrollInLoyaltyModal,
      CollectAccountInfoModal,
      EnterTableNumberModal,
      PrivacyPolicyModal,
      ScanToPayReceiptModal,
      OpenTabFinishOrderingModal,
      OpenTabOnboardingModal,
      CheckGiftCardBalanceModal,
      ConfirmFulfillmentTimeModal,
      SelectTableTopDeviceOrderModal,
      OrderItemRatingModal,
      UnavailableFavoriteItemModal,
      ReadOnlyMenuItemModal
    }
  };
</script>
